import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrmsDropzone/mocker'

export default {
  postRemovedFile ({ file, fileDir }) {
    if (isMock) return generator(mocker.removedFile())
    return instance().post(endpoint + '/uploader/removedFile', { fileName: file.name, fileDir: fileDir })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrmsDropzone/index.js